import StrokedRoundedLinkIcon from "@/components/icons/StrokedRoundedLinkIcon.vue";
import { mapGetters } from "vuex";
export default {
  name: 'ImageElement',
  props: {
    image: String,
    link: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '20'
    },
    height: {
      type: String,
      default: '20'
    },
    styles: {
      type: Object,
      default: () => {}
    },
    withOverlay: {
      type: Boolean,
      default: false
    },
    withFlag: {
      type: Boolean,
      defaulf: false
    },
    flagStyle: {
      type: Object,
      default: () => {}
    },
    countryCode: String,
    borderColor: {
      type: String,
      default: '#dde1e6'
    }
  },
  components: {
    StrokedRoundedLinkIcon
  },
  computed: {
    ...mapGetters(["getCountryFlag"]),
    processedStyles() {
      return {
        ...this.styles,
        border: `1px solid ${this.borderColor}`,
        borderRadius: '4px',
        cursor: !this.link ? 'default' : 'pointer',
        position: 'relative',
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'flex',
        justifyContent: 'center'
      };
    },
    flag() {
      return this.withFlag ? this.getCountryFlag(this.countryCode) : "";
    }
  },
  methods: {
    handleClick() {
      if (!this.link) return;
      let link = this.link;
      if (!link.startsWith("http://") && !link.startsWith("https://")) {
        link = "https://" + link;
      }
      window.open(link, '_blank');
    }
  }
};